<template>
    <v-form @submit.prevent="printReport" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Annualization Reports</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="content-row">
                        <v-select
                            label="Select report"
                            :items="report_types"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="code"
                            v-model="reportCode"       
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="content-row">
                        <v-alert v-if="selected_report" :value="true" color="info" icon="info" outline >
                            <div v-html="selected_report.description"></div>
                        </v-alert> 
                        <v-alert v-if="selected_report&&selected_report.note" :value="true" color="warning" icon="warning" outline >
                            <div v-html="selected_report.note"></div>
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions height="45px">
                <v-spacer></v-spacer>
                <v-btn v-if="selected_report" color="primary" type="submit" :loading="loading" class="mr-20" :title="`Click to ${selected_report.action}`">
                    <v-icon>{{selected_report.icon}}</v-icon>&nbsp;&nbsp;&nbsp;{{selected_report.action}}
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
    </v-form>
</template>
<script>

import annualizationApi from '@/api/annualization'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'

export default {
    components: {
        'preview': () => import('@/components/FilePreview/Preview'),
    },
    data () {
        return {
            error: false,
            errorMessage: null,
            reportCode: null,
            loading: false,
            disabled: false,
            dialogPreview: false,
            report_types: [
                {
                    code: 'SUMMARY1',
                    file_type: 'XLSX',
                    icon: 'fas fa-file-excel',
                    action: 'Export to XLSX',
                    name: 'Annualization Summary',
                    description: 'Summary of employee annualized compensation and tax.',
                    note: ''
                },
                {
                    code: 'DEPOSIT1',
                    file_type: 'PDF',
                    icon: 'fas fa-file-pdf',
                    action: 'Preview PDF',
                    name: 'Adjustments Deposit Slip',
                    description: 'Deposit slip for annualization adjustment payouts.',
                    note: 'Includes only <b>Approved</b> records with <b>positive final adjustments</b>.'
                },
                {
                    code: 'BIR1604C-Summary',
                    file_type: 'PDF',
                    icon: 'fas fa-file-pdf',
                    action: 'Preview PDF',
                    name: 'BIR Form No. 1604-C (Summary)',
                    description: 'Annual summary of compensation and taxes withheld.',
                    note: 'Includes only <b>Approved</b> or <b>Adjustments Processed</b> annualization.'
                },
                {
                    code: 'BIR1604C-Alphalist',
                    file_type: 'XLSX',
                    icon: 'fas fa-file-excel',
                    action: 'Export to XLSX',
                    name: 'BIR Form No. 1604-C (Schedule 1 – Alphalist)',
                    description: 'Alphalist of employees with taxes withheld.',
                    note: 'Includes only <b>Approved</b> or <b>Adjustments Processed</b> annualization.'
                },
                {
                    code: 'BIR1604C-Alphalist-MWE',
                    file_type: 'XLSX',
                    icon: 'fas fa-file-excel',
                    action: 'Export to XLSX',
                    name: 'BIR Form No. 1604-C (Schedule 2 – MWE Alphalist)',
                    description: 'Alphalist of minimum wage earners.',
                    note: 'Includes only <b>Approved</b> or <b>Adjustments Processed</b> annualization.'
                }
            ],
            rules: {
                required: value => !!value || 'Required field'
            },
            fiscalPeriodId: null,
            fiscalYear: null
        }   
    },
    methods: {
        setParam(data) {
            this.$refs.form.reset()
            this.fiscalPeriodId = data.fiscalPeriodId
            this.fiscalYear = data.fiscalYear
        },
        async printReport() {
            try {
                if (this.$refs.form.validate()) {
                    if (this.reportCode=='SUMMARY1') this.generateSummaryReport()
                    if (this.reportCode=='DEPOSIT1') this.previewDepositSllip()
                    if (this.reportCode=='BIR1604C-Summary') this.preview16014Summary()
                    if (this.reportCode=='BIR1604C-Alphalist') this.generate16014_Alphalist()
                    if (this.reportCode=='BIR1604C-Alphalist-MWE') this.generate16014_AlphalistMWE()
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogReports', false)
        },
        async generate16014_Alphalist() {
            try {
                this.loading = true
                const response = await annualizationApi.get1604CAlphalist(this.fiscalPeriodId)
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `BIR-1604-C-Alphalist-CY${this.fiscalYear}.xlsx`
                link.click()
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async generate16014_AlphalistMWE() {
            try {
                this.loading = true
                const response = await annualizationApi.get1604CAlphalistMWE(this.fiscalPeriodId)
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `BIR-1604-C-Alphalist-MWE-CY${this.fiscalYear}.xlsx`
                link.click()
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async previewDepositSllip() {
            try {
                this.loading = true 
                const response = await annualizationApi.getDepositSlipUrl(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    const fileName = response.data.fileName
                    const file = {
                        name: fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getCompanyDocumentUrl(fileName, AWSS3DocumentType.DepositSlips)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async preview16014Summary() {
            try {
                this.loading = true 
                const response = await annualizationApi.get1604CUrl(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    const fileName = response.data.fileName
                    const file = {
                        name: fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getCompanyDocumentUrl(fileName, AWSS3DocumentType.BIR1604)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async generateSummaryReport() {
            try {
                this.loading = true
                const response = await annualizationApi.getSummary(this.fiscalPeriodId)
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Annualization-Summary-CY${this.fiscalYear}.xlsx`
                link.click()
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        }
    },
    computed: {
        selected_report() {
            if (this.reportCode){
                return this.report_types.find(x => x.code == this.reportCode)
            }
        },
    },
    created() {}
}
</script>
<style scoped>
.content-row {
    padding: 0px 15px 0px 15px;
}
</style>